import CsnLogo from '../assets/cases/csn.png';
import BanparaLogo from '../assets/cases/banpara.jpg';
import SefazLogo from '../assets/cases/sefaz.jpg';
import SococoLogo from '../assets/cases/sococo.png';
import DiasBrancoLogo from '../assets/cases/diasbranc.png';

export type caseParamType = keyof typeof casesContents;

export interface ICaseContent {
    title: string;
    logo: string;
    desafio: string;
    resumo: string;
    solucao: string;
    resultado: string;
    video_url: string;
    video_title: string;
    sucessName: string;
}

export const casesContents = {
    csn: {
        title: 'CSN moderniza infraestrutura rumo à Indústria 4.0 com HPE e Decatron',
        logo: CsnLogo,
        desafio: 'Implementação de base para indústria 4.0',
        resumo: 'A CSN iniciou sua jornada rumo à Indústria 4.0 com a integração de soluções em parceria com a Decatron e a HPE, alcançando melhorias significativas em performance, gestão e segurança.',
        solucao: 'Integração de soluções para garantir a performance e agilidade',
        resultado: 'Significativos ganhos de performance, gestão e segurança',
        video_url: 'https://www.youtube.com/embed/fdo8abFUayc?si=PEsrZOen2I1zuN9r',
        video_title: '',
    },
    banpara: {
        title: 'Banpará automatiza e amplia capacidade de TI com VMware vCloud Suite',
        logo: BanparaLogo,
        desafio: `Criar o ambiente de TI necessário para suportar as crescentes necessidades do Mobile e Internet Banking, trazer agilidade e melhor eficiência na utilização dos recursos de TI, aumentar a produtividade do seu pessoal técnico de operação e suporte, além de garantir continuidade, segurança e performance para as diversas outras aplicações criticas suportadas.`,
        resumo: 'Para enfrentar o aumento da demanda por serviços digitais, o Banpará implementou a plataforma vCloud Suite 6 Enterprise, otimizando sua infraestrutura, aumentando a produtividade da equipe técnica e assegurando alta disponibilidade para aplicações críticas.',
        solucao: `Investiram na plataforma vCloud Suite 6 Enterprise, da VMware, que contém tecnologias voltadas para a automação do gerenciamento e provisionamento de aplicativos e infraestruturas, inclusive containers, além de recursos de planejamento de capacidade, gestão de custos e criação da base tecnológica para o uso futuro de soluções em nuvem.`,
        resultado: `Projeto aumentou a disponibilidade, desempenho e eficiência da infraestrutura de TI, oferecendo melhor suporte às aplicações do banco.`,
        video_url: 'https://www.youtube.com/embed/QVwax_ovtWI?si=rUCP_GzK8R5el4hk',
        video_title: '',
    },
    sefaz: {
        title: 'SEFAZ-PI renova parque tecnológico com HPE Synergy e VMware vSAN',
        logo: SefazLogo,
        desafio:
            'Com um parque de servidores, storage e rede obsoleto e defasado, a Sefaz-PI necessitava de uma solução que suportasse o processamento do grande volume de dados provenientes de inúmeros postos fiscais espalhados por todo o estado.',
        resumo: 'A SEFAZ-PI superou os desafios de uma infraestrutura obsoleta com a adoção de HPE Synergy e VMware vSAN, resultando em uma infraestrutura moderna, robusta e escalável, pronta para o crescimento da instituição.',
        solucao:
            'Implementação da solução HPE Synergy integrada ao VMware vSAN para atender às demandas de desempenho e confiabilidade.',
        resultado:
            'Migração bem-sucedida com ganhos expressivos de capacidade e processamento, sem paradas significativas.',
        video_url: 'https://www.youtube.com/embed/Mkrkuyp8ENg?si=db8AW84zduVatBrK',
        video_title: '',
    },
    sococo: {
        title: 'Sococo reduz servidores e ganha eficiência com HPE Simplivity e VMware',
        logo: SococoLogo,
        desafio:
            'Com um parque de servidores, storage e rede obsoleto e defasado, a Sococo buscou no mercado uma solução que pudesse gerar uma nova consolidação de Infraestrutura no seu ambiente, menor consumo de energia, uma melhor distribuição dos recursos virtuais e um gerenciamento de infraestrutura automatizado.',
        resumo: 'A Sococo modernizou sua infraestrutura com HPE Simplivity e VMware, reduzindo de 10 para 3 servidores, otimizando o consumo de energia e centralizando a gestão de forma mais inteligente e eficiente.',
        solucao:
            'Adoção de HPE Simplivity, vSphere Enterprise Plus e switches HPE/Aruba, com foco em automação e eficiência energética.',
        resultado:
            'Ambiente mais enxuto, eficiente e fácil de gerenciar, com alta performance e melhor aproveitamento dos recursos.',
        video_url: '',
        video_title: '',
    },
    dias_branco: {
        title: 'M. Dias Branco prepara fábricas para Indústria 4.0 com HPE Simplivity',
        logo: DiasBrancoLogo,
        desafio: `Atualização dos servidores e storage obsoletos das fábricas e implementação de um ambiente tecnológico virtualizado que evitasse paradas não programadas e suportasse a automação da indústria.`,
        resumo: 'A M. Dias Branco renovou sua infraestrutura com HPE Simplivity e VMware, integrando ambientes fabris e criando uma base sólida para replicação de dados e avanços rumo à Indústria 4.0.',
        solucao:
            'Substituição dos equipamentos por tecnologia de Hiperconvergência HPE Simplivity, com rotinas de backup entre fábricas.',
        resultado:
            'Ambiente robusto, replicação de backups entre unidades e base pronta para evolução tecnológica.',
        video_url: 'https://www.youtube.com/embed/_ZwWHMch2NM?si=6rQE2rd89nG-MBoZ',
        video_title: '',
    },
};
